const mutations = {
    setResponse: (state, payload) => {
        state.response = payload;
    },
    setUser: (state, payload) => {
        state.user = payload;
    },
    setAuth: (state, payload) => {
        state.auth = payload
    },
    setDadosUsuario: (state, payload) => {
        state.dadosUsuario = payload;
    },
    setLayoutTitle: (state, payload) => {
        state.title = payload;
    },
    setLayoutBreadcrumbs: (state, payload) => {
        state.breadcrumbs = payload;
    },
    setLayoutHomeDoubt: (state, payload) => {
        state.layoutHomeDoubt = payload;
    },
    setItemsRandomizedStor: (state, payload) => {
        state.itemsRandomizedStor = payload;
    },
    setItemsOrganizedStor: (state, payload) => {
        state.itemsOrganizedStor = payload;
    },
    setOnFullscreen: (state, payload) => {
        state.onFullscreen = payload;
    },
    changeUserData: (state, payload) => {
        state.user.name = payload.firstName
        state.user.fullName = payload.firstName + " " + payload.lastName
        state.user.phone = payload.phone
    },
    logOutUserData: (state) => {
        state.user = {}
    },
    setSelectedItemMenu: (state, payload) => {
        state.selectedItemMenu = payload;
    },
    setRegisterTab: (state, payload) => {
        state.registerTab = payload;
    },
    setApiDetailsTab: (state, payload) => {
        state.apiDetailsTab = payload;
    },
    setTermsPoliciesData: (state, payload) => {
        state.termsPoliciesData = payload;
    },
    setTermsPoliciesAccepetd: (state, payload) => {
        if (payload.length) {
            payload.map((term) => {
                for (let index = 0; index < state.termsPoliciesAccepetd.length; index++) {
                    if (state.termsPoliciesAccepetd[index].type == term.type) {
                        state.termsPoliciesAccepetd[index].accept = term.accept
                    }
                    if (term.type == "COOKIES" && term.accept) {
                        state.idUserWhoAccepted = state.dadosUsuario && state.dadosUsuario.sub ? state.dadosUsuario.sub : null;
                    }
                }
            })
        }
    },
    setNoUseCookies: (state, payload) => {
        state.noUseCookies = payload;
        state.idUserWhoAccepted = payload && state.dadosUsuario && state.dadosUsuario.sub ? state.dadosUsuario.sub : null;
    },
    setIdUserWhoAccepted: (state, payload) => {
        state.idUserWhoAccepted = payload;
    },
    setCountApproval: (state, payload) => {
        state.countApproval = payload;
    },
    setProfileSelected: (state, payload) => {
        state.profileSelected = payload;
    },
    setMenuGroupsActive: (state, groups) => {
        state.menuGroupsActive = groups;
    },
    setRemoveMenuGroupsActive: (state, item) => {
        state.menuGroupsActive = state.menuGroupsActive.filter(menu => menu != item)
    },
    setHeaderAdminType: (state, payload) => {
        state.headerAdminType = payload;
    }
};

export default mutations;
